import React from 'react'
import OnVisible from 'react-on-visible'

import Img from '../responsiveCloudinary'

import styles from './CSImageBlock.module.scss'

class Template extends React.Component {
  render() {
    let inlineStyle = {
      margin: this.props.margin || null,
      padding: this.props.padding || null,
      backgroundColor: this.props.background || null,
    }

    if (this.props.paddingTop || this.props.paddingBottom) {
      inlineStyle = {
        ...inlineStyle,
        paddingTop: this.props.paddingTop || null,
        paddingBottom: this.props.paddingBottom || null,
      }
    }

    if (this.props.marginTop || this.props.marginBottom) {
      inlineStyle = {
        ...inlineStyle,
        marginTop: this.props.marginTop || null,
        marginBottom: this.props.marginBottom || null,
      }
    }

    return (
      <section
        className={`${styles.block} ${styles[this.props.margin]} ${
          styles[this.props.width]
        }`}
        style={inlineStyle}
      >
        <div className="row">
          {/* If there's a top title */}
          {this.props.textPosition === 'top' && (
            <TextBlock
              title={this.props.title}
              description={this.props.description}
              theme={this.props.textTheme}
              textAlign={this.props.textAlign}
            />
          )}

          <div className="columns large-12">
            {/* If image has animation */}
            {this.props.animation && (
              <OnVisible visibleClassName={`${styles[this.props.animation]}`}>
                <Img
                  user="avenue"
                  className={`${styles[this.props.variation]} ${styles.img} ${
                    styles[this.props.animation + '--initial']
                  }`}
                  publicId={this.props.image}
                  quality={this.props.quality}
                  alt=""
                />
              </OnVisible>
            )}

            {/* If image without animation */}
            {!this.props.animation && (
              <Img
                user="avenue"
                className={`${styles[this.props.variation]}`}
                publicId={this.props.image}
                quality={this.props.quality}
                xlarge={
                  this.props.variation === 'bleedBoth' ? '1800px' : '1600px'
                }
                alt=""
              />
            )}
          </div>

          {/* If there's a bottom title */}
          {this.props.textPosition === 'bottom' && (
            <TextBlock
              title={this.props.title}
              description={this.props.description}
              theme={this.props.textTheme}
              textAlign={this.props.textAlign}
            />
          )}
        </div>
      </section>
    )
  }
}

const TextBlock = ({ title, description, textAlign, theme = 'default' }) => (
  <div className="columns large-12">
    <div
      className={`${styles.textBlock} ${styles[theme]} ${styles[textAlign]}`}
    >
      {title && <h2>{title}</h2>}
      {description && <p>{description}</p>}
    </div>
  </div>
)

export default Template
